module.exports = __webpack_public_path__ + "static/stop2shop-1c295d8b737a537af2146eb4675c6c6f.jpg";